import { useSnapshot } from 'valtio';
import { RepoNode } from '../onboarding-types';
import RepoSelectionStore from '../stores/onboarding-repo-selection-store';

export const setRepoTreeData = (treeData: RepoNode[]) => {
  RepoSelectionStore.repoTreeData = treeData;
};

export const setFilteredRepoTreeData = (treeData: RepoNode[]) => {
  RepoSelectionStore.filteredRepoTreeData = treeData;
};

export const resetRepoSelectionStore = () => {
  RepoSelectionStore.filteredRepoTreeData = null;
  RepoSelectionStore.expandedNodes = [];
  RepoSelectionStore.isChooseAllSelected = true;
  RepoSelectionStore.repoTreeData = null;
  RepoSelectionStore.searchValue = '';
  RepoSelectionStore.isLoading = false;
  RepoSelectionStore.monitorAllNewlyCreatedResources = true;
  RepoSelectionStore.controlObject = {};
};

export const setIsChooseAllSelected = (isSelected: boolean) => {
  RepoSelectionStore.isChooseAllSelected = isSelected;
};

export const setSearchValue = (searchString: string) => {
  RepoSelectionStore.searchValue = searchString;
};

export const setExpandedNodes = (expandedNodes: string[]) => {
  RepoSelectionStore.expandedNodes = expandedNodes;
};

export const setIsLoading = (isLoading: boolean) => {
  RepoSelectionStore.isLoading = isLoading;
};

export const setMonitorAllNewlyCreatedResources = (isChecked: boolean) => {
  RepoSelectionStore.monitorAllNewlyCreatedResources = isChecked;
};

export const useRepoSelection = () => useSnapshot(RepoSelectionStore);
